module.exports = __webpack_public_path__ + "static/media/gilfoyle.a10584b4.jpg";